import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

// Connects to data-controller="splide"
export default class extends Controller {
  static values = {
    arrows: { type: Boolean, default: true },
  };

  connect() {
    new Splide(this.element, {
      arrows: this.arrowsValue,
    }).mount();
  }
}
